/* ============================================================
   Santa Max Experience — site behaviors
   Ported from the approved mockup (rev. 13, 2026-08-25).

   Changed from the mockup on purpose:
   - The mockup was one file with a hash router (#/about, #/mission-story).
     On Shopify those are real pages, so the router is gone. Book links are
     plain "#booking" anchors, and a link to the booking section from another
     page carries ?book=1 so it opens on arrival.
   - Every feature reads its config off data- attributes written by Liquid,
     so the theme editor toggles drive this file rather than code edits.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Horizon scrolls the page inside .page-wrapper on desktop (html/body
     overflow:hidden), but on mobile the wrapper isn't a scroll container
     and the document scrolls normally. Detect the real scroller each time
     rather than assuming — scrolling the wrong element does nothing,
     silently (that was the "Book NOW opens booking but doesn't move"
     mobile bug). scrollIntoView smooth also fails inside Horizon's
     containers, so the glide is animated by hand. */
  function getScroller() {
    var w = document.querySelector('.page-wrapper');
    if (w) {
      var o = getComputedStyle(w).overflowY;
      if ((o === 'auto' || o === 'scroll') && w.scrollHeight > w.clientHeight + 1) return w;
    }
    return document.scrollingElement || document.documentElement;
  }

  /* The glide is SELF-CORRECTING: it re-measures the target's live
     position every frame and eases toward it, instead of computing the
     destination once up front. That matters because the page moves under
     it — the Acuity iframe resizes itself after it loads, which made
     repeat Book NOW clicks scroll to stale coordinates (open-but-no-
     scroll on mobile). Each new glide cancels any in-flight one. */
  var glideToken = 0;
  function glideTo(el) {
    var token = ++glideToken;
    var scroller = getScroller();
    var header = document.querySelector('.santa-header-root header.site');
    var off = (header ? header.offsetHeight : 0) + 10;

    function remaining() {
      var base = (scroller === document.scrollingElement || scroller === document.documentElement)
        ? 0
        : scroller.getBoundingClientRect().top;
      return el.getBoundingClientRect().top - base - off;
    }

    /* Hidden tabs pause requestAnimationFrame, which would leave the glide
       queued until the visitor switches back — jump instantly instead
       (covers links opened into background tabs, and reduced motion). */
    if (reduced || document.hidden) {
      scroller.scrollTo({ top: scroller.scrollTop + remaining(), behavior: 'instant' });
      return;
    }

    var start = performance.now();
    function step() {
      if (token !== glideToken) return; // a newer glide took over
      var r = remaining();
      if (Math.abs(r) < 2 || performance.now() - start > 1200) {
        scroller.scrollTo({ top: scroller.scrollTop + r, behavior: 'instant' });
        return;
      }
      /* ease out: cover 16% of what's left each frame */
      scroller.scrollTo({ top: scroller.scrollTop + r * 0.16, behavior: 'instant' });
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ============ booking expander ============
     The Acuity iframe and its embed script are loaded on the first Book
     click, not at page load — the mockup did this so the booking widget
     never costs anything to visitors who are only browsing. */
  (function () {
    var sec = document.getElementById('booking');
    if (!sec) return;
    var shell = document.getElementById('bookingShell');
    var loaded = false;

    window.openBooking = function (scroll) {
      if (sec.hidden) sec.hidden = false;
      if (!loaded && shell) {
        loaded = true;
        var owner = shell.getAttribute('data-acuity-owner');
        var height = shell.getAttribute('data-acuity-height') || '700';
        var mode = shell.getAttribute('data-acuity-mode') || 'window';
        if (owner) {
          shell.innerHTML =
            '<iframe src="https://app.acuityscheduling.com/schedule.php?owner=' +
            encodeURIComponent(owner) +
            '&ref=embedded_csp" title="Schedule Appointment" width="100%" height="' +
            parseInt(height, 10) +
            '" frameBorder="0" allow="payment"></iframe>';
          /* embed.js only exists to grow the iframe to the scheduler's
             full content height. In "window" mode we deliberately DON'T
             load it: the iframe keeps its fixed height and the scheduler
             scrolls inside itself — wheel on desktop, finger on mobile,
             its own scrollbar on the right. */
          if (mode === 'grow') {
            var s = document.createElement('script');
            s.src = 'https://embed.acuityscheduling.com/js/embed.js';
            s.type = 'text/javascript';
            document.body.appendChild(s);
          }
        }
      }
      // Close the elf chat if it is covering the booking form.
      var panel = document.getElementById('chatPanel');
      if (panel && panel.classList.contains('open')) {
        panel.classList.remove('open');
        var fab = document.getElementById('chatFab');
        if (fab) fab.style.display = 'flex';
      }
      if (scroll) {
        setTimeout(function () { glideTo(sec); }, 30);
      }
    };

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="#booking"], a[href="#booking"]');
      if (!a) return;
      // Same page: expand in place. Different page: let the link navigate,
      // the ?book=1 handler below opens it on arrival.
      var url = a.getAttribute('href');
      if (url.charAt(0) === '#' || url.split('#')[0] === '' ||
          url.split('#')[0] === window.location.pathname) {
        e.preventDefault();
        window.openBooking(true);
        if (history.replaceState) history.replaceState(null, '', '#booking');
      }
    });

    // Arriving from another page, or on a direct #booking link.
    if (/[?&]book=1/.test(window.location.search) ||
        window.location.hash === '#booking') {
      window.openBooking(true);
    }

    // "Always visible" mode: the section renders without the hidden
    // attribute, so load the Acuity embed right away (no scroll).
    if (!sec.hidden) {
      window.openBooking(false);
    }
  })();

  /* ============ santa flyby ============
     Client-supplied sleigh art crosses the top ribbon. First flight a few
     seconds after load, then at random intervals so it feels incidental
     rather than on a metronome. */
  (function () {
    var el = document.getElementById('sleigh');
    if (!el || reduced) return;
    function fly() { el.classList.add('flying'); }
    el.addEventListener('animationend', function (e) {
      if (e.animationName !== 'sleighFly') return;
      el.classList.remove('flying');
      setTimeout(fly, 14000 + Math.random() * 26000);
    });
    window.flySleigh = fly;
    setTimeout(fly, 2500 + Math.random() * 3000);
  })();

  /* ============ elf peek ============
     Twinkle pops out from behind the chat button. Suppressed while the
     chat is open so she never covers her own panel. */
  (function () {
    var pk = document.getElementById('elfPeek');
    if (!pk || reduced) return;
    var img = pk.querySelector('img');
    if (!img) return;
    function peek() {
      var panel = document.getElementById('chatPanel');
      if (!panel || !panel.classList.contains('open')) pk.classList.add('show');
      setTimeout(peek, 9000 + Math.random() * 20000);
    }
    img.addEventListener('animationend', function () { pk.classList.remove('show'); });
    window.peekElf = function () { pk.classList.add('show'); };
    setTimeout(peek, 4000 + Math.random() * 4000);
  })();

  /* ============ mobile menu ============ */
  (function () {
    var b = document.getElementById('santaBurger');
    var m = document.getElementById('santaMobileMenu');
    if (!b || !m) return;
    b.addEventListener('click', function () {
      var open = m.classList.toggle('open');
      b.setAttribute('aria-expanded', open);
    });
    /* Tapping a same-page anchor (Reviews, Our Mission, FAQs on the
       homepage) doesn't reload the page, so the menu used to stay open
       covering the content. Close it on any link tap — for links that DO
       navigate, closing a menu the page is leaving anyway is harmless. */
    m.addEventListener('click', function (e) {
      if (!e.target.closest('a')) return;
      m.classList.remove('open');
      b.setAttribute('aria-expanded', 'false');
    });
  })();

  /* ============ starfield ============ */
  (function () {
    var sf = document.getElementById('starfield');
    if (!sf) return;
    for (var i = 0; i < 42; i++) {
      var s = document.createElement('i');
      s.style.left = (Math.random() * 100) + '%';
      s.style.top = (Math.random() * 100) + '%';
      s.style.animationDelay = (Math.random() * 3) + 's';
      s.style.animationDuration = (2.2 + Math.random() * 2.6) + 's';
      if (Math.random() < .3) { s.style.width = s.style.height = '2px'; }
      sf.appendChild(s);
    }
  })();

  /* ============ snowfall ============
     Canvas rather than DOM nodes: 160 drifting flakes as elements would
     thrash layout on mobile. Flake count scales with viewport width. */
  (function () {
    var canvas = document.getElementById('santa-snow');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var flakes = [], running = false, raf = null;
    var sw = document.getElementById('snowSwitch');

    function size() { canvas.width = innerWidth; canvas.height = innerHeight; }
    window.addEventListener('resize', size);
    size();

    function make(n) {
      flakes = [];
      for (var i = 0; i < n; i++) {
        flakes.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: 1 + Math.random() * 2.6,
          vy: .4 + Math.random() * 1.1,
          drift: Math.random() * 2 * Math.PI,
          ds: .004 + Math.random() * .012,
          o: .35 + Math.random() * .55
        });
      }
    }

    function frame() {
      if (!running) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#fff';
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.drift += f.ds;
        f.x += Math.sin(f.drift) * .6;
        f.y += f.vy;
        if (f.y > canvas.height + 5) { f.y = -5; f.x = Math.random() * canvas.width; }
        if (f.x > canvas.width + 5) f.x = -5;
        if (f.x < -5) f.x = canvas.width + 5;
        ctx.globalAlpha = f.o;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, 2 * Math.PI);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true;
      make(Math.min(160, Math.floor(innerWidth / 9)));
      frame();
    }
    function stop() {
      running = false;
      if (raf) cancelAnimationFrame(raf);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    /* Client decision (Aug 28): snow is on by default everywhere, even
       when the OS reports prefers-reduced-motion — on phones that setting
       was silently killing the snow and it reads as broken, not
       considerate. The header toggle remains the opt-out for anyone who
       wants stillness. (Sleigh and elf-peek still honor reduced motion.) */
    function sync() {
      var on = sw ? sw.checked : true;
      if (on) { start(); } else { stop(); }
    }
    if (sw) {
      sw.addEventListener('change', sync);
    }
    /* Sync now AND again shortly after load: on the live theme the
       checkbox's state at script-eval time proved unreliable (observed
       started-off on Shopify while the toggle showed on), so a delayed
       re-sync heals any startup race with the browser's form-state
       restore. Cheap insurance — start() is a no-op when already running. */
    sync();
    setTimeout(sync, 400);
    window.addEventListener('pageshow', sync);
  })();

  /* ============ Christmas countdown ============
     Computes to the next Dec 25 from today, so it needs no yearly edit.
     Updates EVERY countdown on the page: the footer's original id-based
     cells and any data-cd cells (the footer-CTA copy), so a section can
     host its own instance without touching this file. */
  (function () {
    function targets(unit, id) {
      var list = Array.prototype.slice.call(document.querySelectorAll('[data-cd="' + unit + '"]'));
      var byId = document.getElementById(id);
      if (byId) list.push(byId);
      return list;
    }
    var d = targets('d', 'cdD'), h = targets('h', 'cdH'),
        m = targets('m', 'cdM'), s = targets('s', 'cdS');
    if (!d.length && !h.length) return;
    function set(list, val) {
      for (var i = 0; i < list.length; i++) list[i].textContent = val;
    }
    function tick() {
      var now = new Date();
      var xmas = new Date(now.getFullYear(), 11, 25);
      if (now > xmas) xmas = new Date(now.getFullYear() + 1, 11, 25);
      var ms = xmas - now;
      set(d, Math.floor(ms / 864e5));
      set(h, Math.floor(ms % 864e5 / 36e5));
      set(m, Math.floor(ms % 36e5 / 6e4));
      set(s, Math.floor(ms % 6e4 / 1e3));
      setTimeout(tick, 1000);
    }
    tick();
  })();

  /* ============ newsletter ============
     Front-end only, exactly as the mockup shipped. If the form is wired to
     a real list later (Klaviyo/Mailchimp), replace this block — the
     confirmation copy is worth keeping. */
  (function () {
    var f = document.getElementById('newsForm'), done = document.getElementById('newsDone');
    if (!f || !done) return;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('newsEmail');
      if (!email.value || email.value.indexOf('@') < 0) { email.focus(); return; }
      var name = document.getElementById('newsName').value.trim();
      f.style.display = 'none';
      done.style.display = 'block';
      /* Twinkle is THE elf (Marge, Aug 29) — no Snowball. */
      done.textContent = name
        ? 'Hooray! Twinkle the Elf has added ' + name + ' to the North Pole Post. First workshop update coming soon!'
        : 'Hooray! Twinkle the Elf has added you to the North Pole Post. First workshop update coming soon!';
    });
  })();

  /* ============ elf chat ============
     Scripted keyword replies — no backend, no cost, works offline.
     Facts here (price, dates, pets cutoff) are duplicated from the page
     copy on purpose so the chat still answers if a section is removed;
     if a season fact changes, change it in both places. */
  (function () {
    var panel = document.getElementById('chatPanel'),
        fab = document.getElementById('chatFab'),
        body = document.getElementById('chatBody'),
        typing = document.getElementById('typing'),
        chipsBox = document.getElementById('chips'),
        form = document.getElementById('chatForm'),
        input = document.getElementById('chatText');
    if (!panel || !fab || !body || !form || !input) return;

    var greeted = false, wishMode = false;
    var bookHref = panel.getAttribute('data-book-href') || '#booking';
    var CHIPS = ['Book a visit', 'Prices & dates', 'Can I bring my dog?', 'Contact Us', 'Where are you?'];

    function chips(list) {
      if (!chipsBox) return;
      chipsBox.innerHTML = '';
      list.forEach(function (t) {
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'chip';
        c.textContent = t;
        c.addEventListener('click', function () { send(t); });
        chipsBox.appendChild(c);
      });
    }

    function add(text, who, html) {
      var m = document.createElement('div');
      m.className = 'msg ' + who;
      if (html) { m.innerHTML = text; } else { m.textContent = text; }
      body.insertBefore(m, typing);
      body.scrollTop = body.scrollHeight;
    }

    function elfSay(text, html, delay) {
      if (typing) { typing.style.display = 'block'; body.scrollTop = body.scrollHeight; }
      setTimeout(function () {
        if (typing) typing.style.display = 'none';
        add(text, 'elf', html);
      }, delay || 700 + Math.random() * 500);
    }

    function reply(q) {
      var t = q.toLowerCase();
      if (wishMode) {
        wishMode = false;
        elfSay("Ooooh, wonderful choice! I just wrote “" + q + "” in Santa's Big Book with my sparkliest ink. He reads it every night before bed, pinky promise. Want to tell him in person? A visit makes wishes extra official!", false);
        setTimeout(function () {
          elfSay('You can book right here: <a href="' + bookHref + '">Book NOW!</a>', true, 900);
        }, 1600);
        return;
      }
      if (/book|appoint|schedule|reserve|visit/.test(t)) {
        elfSay('Jingle-tastic! Booking is all online. Pick your date, tell us about your little ones, and Santa will greet them by name. Tap here: <a href="' + bookHref + '">Book NOW!</a>', true);
      } else if (/price|cost|how much|\$|fee/.test(t)) {
        elfSay('Every visit is $60, a private 7-minute appointment just for your family. Want double the magic? Book two back-to-back for a full 14 minutes!', false);
      } else if (/date|hour|open|when|day|time/.test(t)) {
        elfSay("Santa Max is in town November 14 through December 26, closed Thanksgiving and Christmas Day (Santa's a bit busy those two). Early December fills up fast, the reindeer recommend booking soon!", false);
      } else if (/dog|cat|pet|puppy|kitten|animal/.test(t)) {
        elfSay('Yes! Furry family members are welcome through December 18, just keep them on a leash and tell us about them on the registration form so Santa can greet them by name too. The reindeer love visitors!', false);
      } else if (/wish|want for christmas|present|gift|toy/.test(t)) {
        wishMode = true;
        elfSay("Eeee, my favorite job! I'm opening Santa's Big Book right now… What would you like for Christmas? Type it below and I'll write it down!", false);
      } else if (/contact|email|reach|phone|call/.test(t)) {
        elfSay('The fastest way to reach the workshop is email, Mrs. Claus reads every one at <a href="mailto:santa@santamax.co">santa@santamax.co</a>. You can also find us on <a href="http://Facebook.com/santamax88" target="_blank" rel="noopener">Facebook</a> and <a href="https://www.instagram.com/santamaxexperience/" target="_blank" rel="noopener">Instagram</a>!', true);
      } else if (/where|location|address|direction|map|fort mill|charlotte/.test(t)) {
        elfSay('The workshop lands at Heritage Conference Center, 375 Starlight Drive, Fort Mill, SC, under 30 minutes from Charlotte airport. Follow the Santa signs! Map: <a href="https://maps.app.goo.gl/gfYWvsJh7SnQ5pN87" target="_blank" rel="noopener">Google Maps</a>', true);
      } else if (/photo|picture|dropbox|image/.test(t)) {
        elfSay("Your private Dropbox photo link arrives in your reminder emails before your visit even starts, so faraway family can watch the pictures appear live! If a link goes missing, email Mrs. Claus at santa@santamax.co.", false);
      } else if (/cancel|reschedule|change/.test(t)) {
        elfSay('Use the Change/Cancel button in your confirmation email to reschedule. Need a hand? Email Mrs. Claus at santa@santamax.co. Please give us at least 24 hours notice!', false);
      } else if (/grand|family|sister|brother|friend|cousin|group|how many/.test(t)) {
        elfSay('Each visit is for your immediate family, and grandparents are always welcome! Two families? Book back-to-back appointments and share all 14 minutes together, group photos included.', false);
      } else if (/mission|charity|nonprofit|donat/.test(t)) {
        /* Nonprofit language rule (Marge, Aug 29): say "supports missions",
           never a percentage of profits. */
        elfSay('The Santa Max Experience supports missions around the world through Project Noah, a 501(c)(3) nonprofit, from sustainable farms in Mongolia to balloon animals for orphans. Your visit spreads joy twice!', false);
      } else if (/hi|hello|hey|ho ho/.test(t)) {
        elfSay('Well hello there! *jingles bells excitedly* How can this elf help you today?', false);
      } else if (/thank|thanks/.test(t)) {
        elfSay("You're jolly welcome! Anything else? I've got cocoa on the stove but I can multitask.", false);
      } else {
        elfSay("Hmm, that one's above my pay grade in candy canes! For anything tricky, Mrs. Claus reads every email at santa@santamax.co. Or ask me about booking, prices, pets, directions, or tell Santa your Christmas wish!", false);
      }
    }

    function send(text) {
      if (!text) return;
      add(text, 'me');
      input.value = '';
      reply(text);
    }

    function open() {
      panel.classList.add('open');
      fab.style.display = 'none';
      if (!greeted) {
        greeted = true;
        elfSay("Ho ho ho… I mean, hee hee hee! I'm Twinkle, Santa's front-desk elf. I can help you book a visit, answer questions, or write your Christmas wish straight into Santa's Big Book. What'll it be?", false, 600);
        chips(CHIPS);
      }
      setTimeout(function () { input.focus(); }, 300);
    }
    function close() {
      panel.classList.remove('open');
      fab.style.display = 'flex';
    }

    document.querySelectorAll('[data-open-chat]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    var closeBtn = document.getElementById('chatClose');
    if (closeBtn) closeBtn.addEventListener('click', close);
    form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value.trim()); });
  })();
})();